import { ProductItemModel, ProductItemsModel } from '../../../models';
import './ProductItem.css';
import Tilt from 'react-parallax-tilt';
import { useProductItem } from '../../../hooks';
import { Button, Separation } from '../../ui';
import { InspectView } from '../../ui/InspectView';
import { ProductItemTypes } from '../../../enums';
import { ProductItemRaffleDetails } from '.';
import { formatNumber } from '../../../utils';

export function ProductItem(props: {
   productItem: ProductItemModel;
   userTickets: number;
   origin: 'store' | 'my-entries';
   raffles: ProductItemsModel;
   setRaffles: (raffles: ProductItemsModel) => void;
}) {
   const { productItem, userTickets, origin } = props;
   const {
      raffleCountdown,
      inspect,
      setInspect,
      showDetails,
      setShowDetails,
      confirmEntries,
      addToCartQuantity,
      setAddToCartQuantity,
      isLoading,
      isAuthenticated,
      tosAccepted,
      setTosAccepted,
   } = useProductItem(productItem);

   return (
      <>
         <div
            className={`product-item card ${productItem.isFrozen || !raffleCountdown || raffleCountdown?.title.short === 'Starting in' ? 'greyed' : ''}`}
            onClick={() => !productItem.isFrozen && raffleCountdown?.title.short !== 'Starting in' && setInspect(true)}>
            {productItem.raffleStats?.hasWon === true && raffleCountdown?.isLive === false && (
               <div className="product-item-notification">
                  <img
                     src="/assets/icons/trophy-icon.svg"
                     width={28}
                  />
               </div>
            )}
            <div className="product-item-image-container">
               <img
                  src={productItem.product.image}
                  alt=""
               />
            </div>
            <div className="product-item-content flex flex-col">
               <div className="product-item-content-info entries flex justify-between gap-small">
                  <span>{origin === 'my-entries' && 'My '}Entries</span>
                  <div className="green">
                     {origin === 'my-entries' && (productItem.userEntries ? formatNumber(productItem.userEntries) : '0')}
                     {origin === 'store' && (productItem.totalEntries ? formatNumber(productItem.totalEntries) : '0')}
                  </div>
               </div>
               {productItem.isFrozen && (
                  <div className={`product-item-content-info flex justify-between gap-small`}>
                     <span>Coming Soon</span>
                     <div className="flex gap-small blur"></div>
                  </div>
               )}
               {productItem.type === ProductItemTypes.RAFFLE && raffleCountdown && !productItem.isFrozen && (
                  <div className={`product-item-content-info flex justify-between gap-small ${raffleCountdown.title.short === 'Ending in' ? 'active' : ''}`}>
                     <span>{raffleCountdown.title.short}</span>
                     <div className="flex gap-small">
                        {raffleCountdown.hours !== null && raffleCountdown.hours >= 24 && (
                           <span>
                              {Math.floor(raffleCountdown.hours / 24)}
                              <span className="">d</span>
                           </span>
                        )}
                        {raffleCountdown.hours !== null && (
                           <span>
                              {raffleCountdown.hours % 24}
                              <span className="">h</span>
                           </span>
                        )}
                        {raffleCountdown.minutes !== null && (raffleCountdown.hours === null || raffleCountdown.hours < 24) && (
                           <span>
                              {raffleCountdown.minutes}
                              <span className="">m</span>
                           </span>
                        )}
                        {raffleCountdown.minutes === null && raffleCountdown.hours === null && (raffleCountdown.isLive ? <span className="green">Live</span> : <span>Ended</span>)}
                     </div>
                  </div>
               )}
            </div>
         </div>

         <InspectView
            inspect={inspect}
            setInspect={setInspect}
            topContent={
               isAuthenticated && (
                  <div className="flex items-center gap-1">
                     <img
                        className="currency-icon"
                        src="/assets/images/ticket-bg.png"
                        alt=""
                        width={60}
                     />
                     <h2>{formatNumber(userTickets)}</h2>
                  </div>
               )
            }>
            <div className="flex wrap justify-center items-center gap-3 store">
               <Tilt
                  className=""
                  glareEnable={true}
                  glarePosition="top"
                  glareMaxOpacity={0.2}
                  tiltMaxAngleX={7}
                  tiltMaxAngleY={7}>
                  <div className="relative flex justify-center items-center">
                     <div className="inspect-image-container">
                        <img
                           src={productItem.product.image}
                           alt="card"
                           className={`inspect-image green-glow`}
                        />
                     </div>
                  </div>
               </Tilt>
               <div className={`card-info-container  ${productItem.type === ProductItemTypes.RAFFLE ? 'flex flex-col gap-2' : ''}`}>
                  <div className="flex flex-col gap-2">
                     <div className="flex flex-col gap-2">
                        {showDetails && (
                           <div>
                              <Button
                                 type="transparent"
                                 title=""
                                 className="flex gap-1 items-center"
                                 onClick={() => setShowDetails(false)}>
                                 <img
                                    src="/assets/icons/arrow-back.svg"
                                    alt="GolfN"
                                    width={8}
                                 />
                                 <span>Back</span>
                              </Button>
                           </div>
                        )}
                        <h2 className="">{productItem.product.name}</h2>
                     </div>
                     <Separation
                        direction="horizontal"
                        separationColor="#5a5a5a"
                     />
                     <div className={`flex mb-1`}>
                        {productItem.product.details && !showDetails && (
                           <Button
                              type="transparent"
                              title=""
                              className="flex gap-1 items-center underline"
                              onClick={() => setShowDetails(true)}>
                              <span className="">View Details</span>
                              <img
                                 src="/assets/icons/arrow-up-right-icon.svg"
                                 alt=""
                                 width={10}
                              />
                           </Button>
                        )}
                        {!productItem.product.details && productItem.product.description && (
                           <h4 className={`${productItem.product.description?.toLocaleLowerCase() ?? ''}`}>
                              {productItem.product.description && productItem.product.description.toLowerCase()}
                           </h4>
                        )}
                     </div>
                  </div>

                  {showDetails ? (
                     <div className="flex flex-col gap-3">
                        {productItem.product.description && (
                           <span className={`gray small ${productItem.product.description ?? ''}`}>{productItem.product.description && productItem.product.description}</span>
                        )}

                        {productItem.product.details?.map((detail, index) => (
                           <div
                              key={index}
                              className="product-item-details flex flex-col gap-2">
                              <p className="green">{detail.category?.toUpperCase()}</p>
                              {detail.details.map((item, index) => (
                                 <div
                                    key={index}
                                    className="flex justify-between gap-3">
                                    <span className="gray small">{item.key}</span>
                                    <span className="white medium">{item.value}</span>
                                 </div>
                              ))}
                           </div>
                        ))}
                     </div>
                  ) : (
                     <>
                        {productItem.type === ProductItemTypes.RAFFLE && (
                           <ProductItemRaffleDetails
                              productItem={productItem}
                              raffleCountDown={raffleCountdown}
                              addToCartQuantity={addToCartQuantity}
                              setAddToCartQuantity={setAddToCartQuantity}
                              handleBuyEntries={confirmEntries}
                              userTickets={userTickets}
                              isLoading={isLoading}
                              tosAccepted={tosAccepted}
                              setTosAccepted={setTosAccepted}
                           />
                        )}
                     </>
                  )}
               </div>
            </div>
         </InspectView>
      </>
   );
}
